import React, { useContext, useState } from 'react';
import "./Fundallotment.css";
import Application from '../../../StateContext/Application';

const FundAllotment = () => {
  let operation = useContext(Application);
  const { FundAllomentOperation } = operation;

  const [data, setData] = useState({
    fundAllomentType: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const HandleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Data", data);
      let res = await FundAllomentOperation("fundallot" , data);
      console.log("baclkend message : " , res);
    }
    catch (err) {
      console.log(err);
    }
  }




  return (
    <>


      <div className="col-12">
        <h3 className='text-center fw-bold bg-light'>Fund Alloment</h3>
        <div className="col-12 m-auto my-5 fundAllomentContainer">
          <div className="m-auto budgetElement">

            <form action="" >

              <div className="col-12 elements">
                <div className="row">
                  <div className="col-4 my-auto ">
                    <label className='my-auto' >Fund Allotment Type </label>
                  </div>
                  <div className="col-8">
                    <input type="text" placeholder='Enter Fund Allotment Type' value={data.fundAllomentType} name='fundAllomentType' onChange={(handleChange)} />
                  </div>
                </div>
              </div>

              <div className="col-12 text-center my-4 mt-5">
                <button className='btn btn-success px-4' onClick={HandleSubmit}>Submit</button>
              </div>
            </form>

          </div>
        </div >
      </div >





    </>
  )
}

export default FundAllotment;